import { render, staticRenderFns } from "./PricingFaq.vue?vue&type=template&id=a9f04814"
import script from "./PricingFaq.vue?vue&type=script&lang=js"
export * from "./PricingFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports